import m from "./../../../dist/es2015/locales/th_TH.js";
export const am5locales_th_TH = m;